module.exports = __webpack_public_path__ + "img/img6.dc657258.png";